import React, { useState } from 'react';

import { useCommunityViewContext } from 'components/View/CommunityViewContext';

import CMASummarySelect from './CMASummarySelect';
import CMASummaryViewFilterDropdown from './CMASummaryViewFilterDropdown';
import { CMASummaryFilters } from '../types';

const CMASummaryViewFilter = () => {
  const [open, setOpen] = useState(false);
  const { viewFilters } = useCommunityViewContext();
  const filters = viewFilters as CMASummaryFilters;

  return (
    <CMASummarySelect
      open={open}
      onDropdownVisibleChange={(visible) => setOpen(visible)}
      value={filters?.roomComparisonType}
      dropdownRender={() => <CMASummaryViewFilterDropdown onClose={() => setOpen(false)} />}
      labelRender={() => <span>View</span>}
      dataTestId="view-filter"
    />
  );
};

export default CMASummaryViewFilter;
